import {
  DIRECT_PAYMENTS_ACH_ROUTE,
  DIRECT_PAYMENTS_DEBIT_CARD_ROUTE,
  DIRECT_PAYMENTS_ROUTE
} from './route-names'
import DirectPaymentContainer from '@/components/direct-payments/DirectPaymentContainer'
import i18n from '@/i18n'
import { TangoCardColors } from '@tangocard/swag'

export const directPaymentRoutes = [
  {
    path: 'direct-payments',
    name: DIRECT_PAYMENTS_ROUTE,
    component: {
      name: DIRECT_PAYMENTS_ROUTE,
      render: createElement => createElement('router-view')
    },
    children: [
      {
        path: 'ach',
        name: DIRECT_PAYMENTS_ACH_ROUTE,
        component: DirectPaymentContainer,
        meta: {
          segmentName: 'ACH Direct Payment',
          h1: {
            text: i18n.t('directPayments.ach.title'),
            icon: {
              name: 'mdi-lock',
              color: TangoCardColors.black_700
            }
          },
          h2: {
            text: i18n.t('directPayments.ach.subTitle')
          }
        }
      },
      {
        path: 'debit-card',
        name: DIRECT_PAYMENTS_DEBIT_CARD_ROUTE,
        component: DirectPaymentContainer,
        meta: {
          segmentName: 'Debit Card Direct Payment',
          h1: {
            text: i18n.t('directPayments.debitCard.title'),
            icon: {
              name: 'mdi-lock',
              color: TangoCardColors.black_700
            }
          },
          h2: {
            text: i18n.t('directPayments.debitCard.subTitle')
          }
        }
      }
    ]
  }
]
